import { TradingTokenSearchField } from '../../../replicant/features/offchainTrading/offchainTrading.asyncGetters';
import { TradingSearchResult } from '../../../replicant/features/offchainTrading/offchainTrading.properties';
import { REPLICANT_UPLOAD_LENGTH_LIMIT } from '../../../replicant/features/offchainTrading/offchainTrading.ruleset';
import { TradingTokenListing } from '../../../replicant/features/offchainTrading/types';
import { Optional, Fn } from '../../types';

export const tokenListFilters = {
  searchable: {
    Hot: 'hotTxsCount',
    Top: 'supply',
    New: 'availableAt',
  } satisfies Record<string, TradingTokenSearchField>,
  user: {
    Created: '',
    Owned: '',
    Farming: '',
  },
};
export type SearchFilters = keyof typeof tokenListFilters.searchable;
export type UserMemeFilters = keyof typeof tokenListFilters.user;
export type MemeFilters = SearchFilters | UserMemeFilters;

export type GetTokenStrategy =
  | 'fetch'
  | 'forceFetch'
  | 'fetchAndUpdate'
  | 'cacheOnly';

export const newTokenFormConfig = {
  image: {
    title: '',
    placeholder: '',
    required: true,
    dataOnly: true,
    validate: (str: string) => {
      const file = new File([str], 'filename');
      // @todo: is it possible to increase this limit?
      return file.size <= REPLICANT_UPLOAD_LENGTH_LIMIT;
    },
  },
  name: {
    title: 'Token Name',
    placeholder: 'Best token name ever',
    validate: (str: string) => str.length > 0,
    required: true,
  },
  ticker: {
    title: 'Ticker',
    placeholder: 'BTC',
    // limit max 8 chars
    transformInput: (value: string) => value.toUpperCase().substring(0, 8),
    validate: (str: string) =>
      str.length >= 3 && str.length <= 8 && /^[a-zA-Z0-9]+$/.test(str),
    required: true,
  },
  description: {
    title: 'Description',
    placeholder: 'The coolest of them all',
    validate: (str: string) => str.length > 0,
    required: true,
  },
  telegramChannelLink: {
    title: 'Telegram - https://t.me/',
    placeholder: 'Paste Link',
    validate: (str: string) =>
      str.length === 0 || str.startsWith('https://t.me/'),
    required: false,
  },
  telegramChatLink: {
    title: 'Telegram chat - https://t.me/joinchat/',
    placeholder: 'Paste Link',
    validate: (str: string) =>
      str.length === 0 || str.startsWith('https://t.me/joinchat/'),
    required: false,
  },
  twitterLink: {
    title: 'Twitter - https://x.com/',
    placeholder: 'Paste Link',
    validate: (str: string) =>
      str.length === 0 || str.startsWith('https://x.com/'),
    required: false,
  },
} as const;

export const updateTokenFormConfig = {
  telegramChannelLink: {
    title: 'Telegram channel link',
    placeholder: 'Paste Link',
    validate: (str: string) =>
      str.length === 0 || str.startsWith('https://t.me/'),
    required: false,
  },
  telegramChatLink: {
    title: 'Telegram chat link',
    placeholder: 'Paste Link',
    validate: (str: string) =>
      str.length === 0 || str.startsWith('https://t.me/joinchat/'),
    required: false,
  },
  twitterLink: {
    title: 'Twitter link',
    placeholder: 'Paste Link',
    validate: (str: string) =>
      str.length === 0 || str.startsWith('https://x.com/'),
    required: false,
  },
} as const;
